import { z } from "zod";

export const sourcesSearchSchema = z.object({
	/** Run open in the detail sheet. */
	run: z.string().optional(),
});

export const SOURCE_TABS = [
	"overview",
	"fetching",
	"settings",
	"history",
] as const;
export type SourceTab = (typeof SOURCE_TABS)[number];

export const HISTORY_FILTERS = [
	"SYNC",
	"DELTA",
	"INGEST",
	"ENRICH",
	"EMBED",
	"FAILED",
] as const;
export type HistoryFilter = (typeof HISTORY_FILTERS)[number];

export const sourceSearchSchema = z.object({
	tab: z.enum(SOURCE_TABS).optional(),
	run: z.string().optional(),
	/** History tab: one step, or only the runs that failed. */
	show: z.enum(HISTORY_FILTERS).optional(),
	/** How "Connect with Zid" ended: "ok", or why it did not (set by the OAuth callback). */
	connect: z.string().max(500).optional(),
});
